import request from '@/common/request';

export function fetchMerchantTransactionList(params) {
	return request({
		url: `/pg/merchant/${params.merchant_seq}/transaction`,
		method: 'get',
		params,
	});
}
